import { Box, Stack, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  const routeToHome = () => {
    navigate(-1);
  };

  const styles = {
    section: {
      backgroundColor: "rgb(173, 240, 228)",
      // rgb(173, 240, 228)
    },
    container: {
      margin: "0 auto",
      padding: "3rem 1.5rem",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      gap: "3rem",
    },
    content: {
      width: "100%",
      display: "flex",
      alignItems: "center",
    },
    textBlue500: {
      color: "#3b82f6",
    },
    textBlue400: {
      color: "#60a5fa",
    },
    textGray800: {
      color: "#374151",
    },
    textWhite: {
      color: "#fff",
    },
    button: {
      backgroundColor: "#c2fbd7",
      borderRadius: "100px",
      boxShadow:
        "rgba(44, 187, 99, .2) 0 -25px 18px -14px inset,rgba(44, 187, 99, .15) 0 1px 2px,rgba(44, 187, 99, .15) 0 2px 4px,rgba(44, 187, 99, .15) 0 4px 8px,rgba(44, 187, 99, .15) 0 8px 16px,rgba(44, 187, 99, .15) 0 16px 32px",
      color: "green",
      cursor: "pointer",
      display: "inline-block",
      padding: "7px 20px",
      textAlign: "center",
      textDecoration: "none",
      transition: " 250ms",
      border: 0,
      fontSize: "16px",
      userSelect: "none",
      touchAction: "manipulation",
    },
    buttonHover: {
      boxShadow:
        "rgba(44,187,99,.35) 0 -25px 18px -14px inset, rgba(44,187,99,.25) 0 1px 2px, rgba(44,187,99,.25) 0 2px 4px, rgba(44,187,99,.25) 0 4px 8px, rgba(44,187,99,.25) 0 8px 16px, rgba(44,187,99,.25) 0 16px 32px",
      transform: "scale(1.05)",
    },
  };

  return (
    <Box style={styles.section}>
      <Stack style={styles.container}>
        <Stack style={styles.content}>
          <Stack
            style={{
              position: "relative",
              width: "100%",
              marginTop: "3rem",
              maxWidth: "32rem",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <img
              style={{ width: "100%", maxWidth: "32rem" }}
              src="https://media2.giphy.com/media/UoeaPqYrimha6rdTFV/giphy.gif"
              alt="Logo"
            />
          </Stack>
          <Typography
            variant="h3"
            sx={{ fontFamily: "cursive" }}
            style={styles.textGray800}
          >
            Page not found
          </Typography>
          <Typography variant="subtitle1">
            Sorry, the page you are looking for doesn't exist.
          </Typography>
          <Button
            style={styles.button}
            onClick={routeToHome}
            sx={{
              width: "300px",
              marginTop: "12px",
              "&:hover": styles.buttonHover,
            }}
          >
            Take me Back
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

export default NotFound;
